import securedAxios from '~/javascript/utils/axios'

const axios = securedAxios()

// Internal (authenticated) endpoints
export function getOnboarding(businessId) {
  return axios.get(`/ajax/businesses/${businessId}/onboarding`)
}
export function createOnboarding(businessId, data) {
  return axios.post(`/ajax/businesses/${businessId}/onboarding`, data)
}
export function updateOnboardingStep(businessId, step, data) {
  return axios.patch(`/ajax/businesses/${businessId}/onboarding/update_step`, { step, ...data })
}
export function sendOnboardingToClient(businessId) {
  return axios.post(`/ajax/businesses/${businessId}/onboarding/send_to_client`)
}
export function completeOnboarding(businessId) {
  return axios.post(`/ajax/businesses/${businessId}/onboarding/complete`)
}
export function getTeamMembers() {
  return axios.get('/ajax/team_members')
}
export function fireWebhooks(businessId) {
  return axios.post(`/ajax/businesses/${businessId}/onboarding/fire_webhooks`)
}

// Public (token-based) endpoints
export function getOnboardingByToken(token) {
  return axios.get(`/onboarding/${token}/data`)
}
export function updateOnboardingStepByToken(token, step, data) {
  return axios.patch(`/onboarding/${token}/step`, { step, ...data })
}
export function submitOnboardingByToken(token) {
  return axios.post(`/onboarding/${token}/submit`)
}
